/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import { WithChildren } from '@investown/fe/common-utils';

import { ColorsName } from 'styles/theme';

type Align = 'left' | 'center' | 'right';
interface Props extends WithChildren {
  color?: ColorsName;
  align?: Align;
}

const HugeHeading: FC<Props> = ({ color = 'textColor', align, children, ...rest }) => (
  <StyledHeading color={color} align={align} {...rest}>
    {children}
  </StyledHeading>
);

const StyledHeading = styled.h1<{ color: ColorsName; align?: Align }>`
  color: ${(props) => props.theme.color[props.color]};
  margin-bottom: 0;
  font-size: ${({ theme }) => theme.font.size.huge};
  font-weight: ${(props) => props.theme.font.weight.semiBold};
  ${({ align }) =>
    align &&
    css`
      text-align: ${align};
    `}
`;

export default HugeHeading;
